module.exports = __webpack_public_path__ + "img/nl.80be2620.svg";